import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function OfferCountdown() {
  const {
    minutes,
    seconds
  } = useCountdown(15 * 60 - 27);
  return <div className="offer-card rounded-2xl px-6 py-7 text-center" data-id="element-111" data-mp="203zgp16m6ko4">
      <p className="font-display text-[22px] font-semibold tracking-[-0.01em] text-white" data-id="element-112" data-mp="24y3p7ovj30rb">
        Offer <span className="underline decoration-2 underline-offset-4" data-id="element-113" data-mp="28x444wavxj91">only for today</span>!
      </p>

      <p className="mx-auto mt-3 max-w-[300px] text-[14.5px] leading-[1.55] text-white/90" data-id="element-114" data-mp="1c9g4pvilsfet">
        Your spot is reserved for <span className="font-semibold text-white" data-id="element-115" data-mp="1h7hn0e87gap8">15 minutes</span>. If
        you don't complete it,{' '}
        <span className="font-semibold text-white" data-id="element-116" data-mp="1laxlzh7qyn53">the discount goes to the next person</span>.
      </p>

      <div className="mt-6 flex items-start justify-center gap-3" data-id="element-117" data-mp="1q5jmuqg7cxax">
        <TimeBox value={minutes} label="Minutes" data-id="element-118" data-mp="2wnghimowg870" />
        <TimeBox value={seconds} label="Seconds" data-id="element-119" data-mp="31mt5jariblb6" />
      </div>
    </div>;
}
type TimeBoxProps = {
  value: string;
  label: string;
};
function TimeBox({
  value,
  label
}: TimeBoxProps) {
  return <div className="w-[92px]" data-id="element-120" data-mp="21qztftfokrsp">
      <div className="rounded-xl bg-white px-3 py-3.5" data-id="element-121" data-mp="21rrrdawr31m5">
        <p className="font-display text-[30px] font-semibold leading-none tracking-[-0.02em] text-gold-500" data-id="element-122" data-mp="1wrn7dawmvor6">
          {value}
        </p>
      </div>
      <p className="mt-2 text-[13px] text-white/90" data-id="element-123" data-mp="1rrr3rcrulzc5">{label}</p>
    </div>;
}